var _path, _g, _path2, _path3, _path4, _path5, _path6, _g2, _path7, _g3, _path8, _g4, _path9, _g5, _path0, _g6, _path1, _g7, _path10, _g8, _path11, _g9, _path12, _g0, _path13, _g1, _path14, _g10, _path15, _g11, _path16, _path17, _path18, _g12, _path19, _g13, _path20, _g14, _path21, _g15, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _g16, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfficeNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2001_14221)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2001_14221",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 95,
    width: 500,
    height: 403
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M500 95H0V498H500V95Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2001_14221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.9 557.1C168.422 557.1 211 514.522 211 462C211 409.478 168.422 366.9 115.9 366.9C63.3775 366.9 20.7998 409.478 20.7998 462C20.7998 514.522 63.3775 557.1 115.9 557.1Z",
    fill: "#F0EFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.759 354.68C131.968 354.68 147.539 339.109 147.539 319.9C147.539 300.692 131.968 285.12 112.759 285.12C93.551 285.12 77.9795 300.692 77.9795 319.9C77.9795 339.109 93.551 354.68 112.759 354.68Z",
    fill: "#F0EFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.16 517.28C394.416 517.28 450.56 461.136 450.56 391.88C450.56 322.623 394.416 266.48 325.16 266.48C255.903 266.48 199.76 322.623 199.76 391.88C199.76 461.136 255.903 517.28 325.16 517.28Z",
    fill: "#F0EFEF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7598 109.02L106.32 312.64L402.7 327.18L415.24 111.54L84.7598 109.02Z",
    fill: "#7C95CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7793 115.04L111.839 307.62L395.679 321.66L407.599 116.92L90.7793 115.04Z",
    fill: "#CEDEF2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2001_14221",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 90,
    y: 115,
    width: 318,
    height: 207
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7793 115.04L111.839 307.62L395.679 321.66L407.599 116.92L90.7793 115.04Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2001_14221)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7793 191.78L127.879 189.76L141.419 319.16L175.019 322.66L163.999 231.9L207.119 229.9L216.639 327.18H257.279L252.759 246.94L319.959 246.44L319.459 329.68L358.079 328.68L356.579 183.76L412.239 185.76L402.699 344.74L101.799 332.2L91.7793 191.78Z",
    fill: "#8FC8E2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2001_14221",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 183,
    width: 322,
    height: 162
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7793 191.78L127.879 189.76L141.419 319.16L175.019 322.66L163.999 231.9L207.119 229.9L216.639 327.18H257.279L252.759 246.94L319.959 246.44L319.459 329.68L358.079 328.68L356.579 183.76L412.239 185.76L402.699 344.74L101.799 332.2L91.7793 191.78Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2001_14221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.52 194.96L124.88 194.28L137.42 311.64L133.14 312.14L118.52 194.96Z",
    fill: "#C8E6F2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2001_14221",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 183,
    width: 322,
    height: 162
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7793 191.78L127.879 189.76L141.419 319.16L175.019 322.66L163.999 231.9L207.119 229.9L216.639 327.18H257.279L252.759 246.94L319.959 246.44L319.459 329.68L358.079 328.68L356.579 183.76L412.239 185.76L402.699 344.74L101.799 332.2L91.7793 191.78Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2001_14221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.339 195.28L124.619 310.64L120.859 310.38L108.819 195.04L113.339 195.28Z",
    fill: "#C8E6F2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2001_14221",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 183,
    width: 322,
    height: 162
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7793 191.78L127.879 189.76L141.419 319.16L175.019 322.66L163.999 231.9L207.119 229.9L216.639 327.18H257.279L252.759 246.94L319.959 246.44L319.459 329.68L358.079 328.68L356.579 183.76L412.239 185.76L402.699 344.74L101.799 332.2L91.7793 191.78Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2001_14221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.0391 196.28L103.059 196.04L114.099 309.62L109.579 308.12L98.0391 196.28Z",
    fill: "#C8E6F2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_2001_14221",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 183,
    width: 322,
    height: 162
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7793 191.78L127.879 189.76L141.419 319.16L175.019 322.66L163.999 231.9L207.119 229.9L216.639 327.18H257.279L252.759 246.94L319.959 246.44L319.459 329.68L358.079 328.68L356.579 183.76L412.239 185.76L402.699 344.74L101.799 332.2L91.7793 191.78Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_2001_14221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.7795 205.06L127.64 202.3L127.88 206.58L96.0395 208.32L98.7995 220.36L129.14 216.1V218.6L99.5395 223.38L101.8 237.16L130.64 232.14L130.9 235.66L102.56 239.92L104.06 252.2L132.4 248.7L132.64 250.96L103.56 254.96L105.56 270.76L106.06 267.76L133.9 264.5L134.16 267.5L106.56 271.26L107.82 285.06L135.4 282.04L135.9 285.06L107.58 287.32L108.82 299.6L137.16 297.34L137.92 299.86L108.08 302.36L106.06 295.58L93.0195 207.08L95.7795 205.06Z",
    fill: "#8FC8E2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_2001_14221",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 183,
    width: 322,
    height: 162
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7793 191.78L127.879 189.76L141.419 319.16L175.019 322.66L163.999 231.9L207.119 229.9L216.639 327.18H257.279L252.759 246.94L319.959 246.44L319.459 329.68L358.079 328.68L356.579 183.76L412.239 185.76L402.699 344.74L101.799 332.2L91.7793 191.78Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_2001_14221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.579 187.52L362.579 284.8H366.859L367.099 187.26L361.579 187.52Z",
    fill: "#C8E6F2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_2001_14221",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 183,
    width: 322,
    height: 162
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7793 191.78L127.879 189.76L141.419 319.16L175.019 322.66L163.999 231.9L207.119 229.9L216.639 327.18H257.279L252.759 246.94L319.959 246.44L319.459 329.68L358.079 328.68L356.579 183.76L412.239 185.76L402.699 344.74L101.799 332.2L91.7793 191.78Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_2001_14221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M372.859 284.3V188.021L378.879 188.26L377.379 283.8L372.859 284.3Z",
    fill: "#C8E6F2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_2001_14221",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 183,
    width: 322,
    height: 162
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7793 191.78L127.879 189.76L141.419 319.16L175.019 322.66L163.999 231.9L207.119 229.9L216.639 327.18H257.279L252.759 246.94L319.959 246.44L319.459 329.68L358.079 328.68L356.579 183.76L412.239 185.76L402.699 344.74L101.799 332.2L91.7793 191.78Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_2001_14221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.899 188.26L384.159 306.62H388.159L390.679 188.52L384.899 188.26Z",
    fill: "#C8E6F2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_2001_14221",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 183,
    width: 322,
    height: 162
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7793 191.78L127.879 189.76L141.419 319.16L175.019 322.66L163.999 231.9L207.119 229.9L216.639 327.18H257.279L252.759 246.94L319.959 246.44L319.459 329.68L358.079 328.68L356.579 183.76L412.239 185.76L402.699 344.74L101.799 332.2L91.7793 191.78Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_2001_14221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.679 189.021L390.919 319.4L393.939 319.661L399.439 189.021H394.679Z",
    fill: "#C8E6F2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_2001_14221",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 183,
    width: 322,
    height: 162
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7793 191.78L127.879 189.76L141.419 319.16L175.019 322.66L163.999 231.9L207.119 229.9L216.639 327.18H257.279L252.759 246.94L319.959 246.44L319.459 329.68L358.079 328.68L356.579 183.76L412.239 185.76L402.699 344.74L101.799 332.2L91.7793 191.78Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_2001_14221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.079 197.04L401.459 197.3L400.699 201.3L359.079 200.56L360.079 214.84L399.959 215.1V218.36L360.079 217.86L359.839 236.42H398.939L398.439 240.18L359.839 239.92L360.079 259.72L398.439 257.72V261.98L359.579 263.5L360.339 280.8L396.939 281.8L397.199 285.3L360.079 284.3L361.339 302.86L396.699 302.6L396.439 306.38L358.819 305.62L354.819 199.3L359.079 197.04Z",
    fill: "#8FC8E2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_2001_14221",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 183,
    width: 322,
    height: 162
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7793 191.78L127.879 189.76L141.419 319.16L175.019 322.66L163.999 231.9L207.119 229.9L216.639 327.18H257.279L252.759 246.94L319.959 246.44L319.459 329.68L358.079 328.68L356.579 183.76L412.239 185.76L402.699 344.74L101.799 332.2L91.7793 191.78Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_2001_14221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.999 234.4L178.039 326.44L211.879 328.94L204.359 233.66L199.599 233.9L207.119 325.68L200.359 325.18L193.839 233.66L188.059 233.9L195.839 324.42L189.319 324.18L181.799 234.16L175.519 234.4L185.559 323.42L182.039 323.18L171.759 233.9L166.999 234.4Z",
    fill: "#C8E6F2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_2001_14221",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 183,
    width: 322,
    height: 162
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7793 191.78L127.879 189.76L141.419 319.16L175.019 322.66L163.999 231.9L207.119 229.9L216.639 327.18H257.279L252.759 246.94L319.959 246.44L319.459 329.68L358.079 328.68L356.579 183.76L412.239 185.76L402.699 344.74L101.799 332.2L91.7793 191.78Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_2001_14221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.28 326.44C263.04 326.44 256.26 249.2 256.26 249.2H261.28L266.54 326.94H271.56L266.8 248.96L272.56 249.46L276.58 327.2L282.6 326.94L278.34 249.96L284.1 249.7L287.62 327.18L293.64 327.94L290.38 249.96H296.4L299.16 329.44L298.9 333.46L261.28 332.2L262.28 326.44Z",
    fill: "#C8E6F2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_2001_14221",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 183,
    width: 322,
    height: 162
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7793 191.78L127.879 189.76L141.419 319.16L175.019 322.66L163.999 231.9L207.119 229.9L216.639 327.18H257.279L252.759 246.94L319.959 246.44L319.459 329.68L358.079 328.68L356.579 183.76L412.239 185.76L402.699 344.74L101.799 332.2L91.7793 191.78Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_2001_14221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.24 242.68L210.639 239.42V242.42L162.999 246.44L162.24 256.46L213.399 250.2L250.52 258.48L301.679 256.22L301.42 259.48L249.02 262.24L212.399 253.46L162.24 259.98L163.499 269.5L211.899 263.48L254.279 271L301.179 267.74L300.92 271.76L253.779 274.76L212.66 266.24L162.259 273.26L163.259 287.3L216.919 279.02L252.52 284.28L304.92 280.52L305.679 284.28L251.999 288.32L216.899 282.3L162.74 291.58L165.499 306.12L222.179 297.34L256.279 301.36L309.179 294.84C309.179 294.84 308.84 299.1 308.76 298.6C308.68 298.1 255.259 306.12 255.259 306.12L221.399 300.86L162.979 310.14L163.479 320.92L228.179 312.64L255.02 313.9L311.179 309.38C311.179 309.38 312.939 313.4 311.179 313.14C309.419 312.88 158.479 324.92 158.479 324.92L157.479 245.68L163.24 242.68Z",
    fill: "#8FC8E2"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_2001_14221",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 90,
    y: 115,
    width: 318,
    height: 207
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7793 115.04L111.839 307.62L395.679 321.66L407.599 116.92L90.7793 115.04Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_2001_14221)"
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M149.939 324.68C150.939 323.18 129.879 159.68 129.879 159.68L149.439 143.64L167.999 328.68L229.179 331.18L217.139 213.82L244.219 212.82L253.239 333.68L305.899 335.18L299.379 189.24L334.979 184.72V332.66L348.019 333.66L347.519 243.38L388.139 245.88V340.66L149.419 336.64L149.939 324.68Z",
    fill: "#8FD1DC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_2001_14221",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 129,
    y: 143,
    width: 260,
    height: 198
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M149.939 324.68C150.939 323.18 129.879 159.68 129.879 159.68L149.439 143.64L167.999 328.68L229.179 331.18L217.139 213.82L244.219 212.82L253.239 333.68L305.899 335.18L299.379 189.24L334.979 184.72V332.66L348.019 333.66L347.519 243.38L388.139 245.88V340.66L149.419 336.64L149.939 324.68Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_2001_14221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.398 162.18L157.218 342.22L331.238 343.48L331.498 189.26L324.978 190.78L327.738 338.72L321.458 338.46L321.218 190.78L314.438 191.78L317.458 338.72L314.698 338.46L309.938 192.02L304.918 192.78L310.438 337.96L249.998 328.44L240.218 215.1L234.198 215.84L245.978 326.18L241.718 323.92L230.938 215.84L226.178 215.6L237.718 322.66L233.698 322.16L223.418 215.1L219.398 215.34L230.938 322.16L164.238 319.66L147.438 150.16L144.178 152.9L161.978 320.92L159.478 320.66L141.678 154.92L138.418 157.68L157.218 320.92H155.958L136.158 159.42L132.398 162.18Z",
    fill: "#7DC5CB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_2001_14221",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 129,
    y: 143,
    width: 260,
    height: 198
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M149.939 324.68C150.939 323.18 129.879 159.68 129.879 159.68L149.439 143.64L167.999 328.68L229.179 331.18L217.139 213.82L244.219 212.82L253.239 333.68L305.899 335.18L299.379 189.24L334.979 184.72V332.66L348.019 333.66L347.519 243.38L388.139 245.88V340.66L149.419 336.64L149.939 324.68Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_2001_14221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.799 330.2L351.559 246.7L356.819 247.2L356.579 327.94L360.579 328.44L360.839 247.94L366.099 248.7L365.099 328.68L370.119 329.18L370.619 249.2H375.619L375.379 329.68L380.899 329.94L379.639 249.2L384.899 249.44L385.399 333.7L351.799 330.2Z",
    fill: "#7DC5CB"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_2001_14221",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 90,
    y: 115,
    width: 318,
    height: 207
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7793 115.04L111.839 307.62L395.679 321.66L407.599 116.92L90.7793 115.04Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_2001_14221)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M75.3994 172.88C78.0794 171.54 189.739 110.02 189.739 110.02L209.139 112.02L84.0794 183.26L87.0794 244.44L301.719 112.04C301.719 112.04 328.799 114.04 327.139 114.04C325.459 114.04 94.4394 272.86 94.4394 272.86L96.1194 314.66C96.1194 314.66 384.979 114.06 386.999 114.06C388.999 114.06 405.719 115.06 405.719 115.06L119.519 319.66L237.879 322.66L410.399 173.54L409.399 186.58L258.279 326L317.459 324.66L404.719 249.44L403.039 261.14L322.799 334.02L76.0594 331.34L75.3994 172.88Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_2001_14221",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 90,
    y: 115,
    width: 318,
    height: 207
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7793 115.04L111.839 307.62L395.679 321.66L407.599 116.92L90.7793 115.04Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_2001_14221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.679 112.38L165.659 314.64L170.339 315.32L177.359 112.7L270.639 114.72L269.299 317.32L274.319 317.66L275.659 113.38L355.559 114.38L329.159 322.66L331.819 323L360.239 113.38L172.359 110.7L171.679 112.38Z",
    fill: "#7C95CC"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M259.26 481.32C257.12 481.58 255.1 479.7 254.76 477.12C246.7 416.52 238.64 355.92 230.56 295.34C230.22 292.76 232.34 290.34 235.28 289.98C238.22 289.62 240.88 291.42 241.18 294.02C248.3 354.74 255.44 415.44 262.56 476.16C262.88 478.72 261.4 481.06 259.26 481.32Z",
    fill: "#BCBEC0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M376.06 490.241C374.48 490.501 372.9 489.101 372.54 487.101C364.18 440.201 355.82 393.321 347.44 346.421C347.08 344.421 348.58 342.481 350.76 342.101C352.94 341.721 355 343.061 355.32 345.061C363 392.061 370.66 439.081 378.34 486.081C378.66 488.121 377.62 489.981 376.06 490.241Z",
    fill: "#BCBEC0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M340.4 475.62C338.8 475.8 337.3 474.32 337.04 472.3C331.14 425.04 325.26 377.76 319.36 330.5C319.1 328.48 320.7 326.62 322.9 326.38C325.1 326.12 327.08 327.56 327.3 329.58C332.5 376.92 337.68 424.28 342.88 471.62C343.12 473.64 342 475.44 340.4 475.62Z",
    fill: "#BCBEC0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M299.66 494.221C298.08 494.021 296.96 492.201 297.2 490.201C302.78 442.901 308.38 395.601 313.96 348.301C314.2 346.281 316.18 344.861 318.38 345.141C320.58 345.421 322.16 347.281 321.88 349.301C315.6 396.521 309.3 443.721 303.02 490.941C302.76 492.921 301.24 494.421 299.66 494.221Z",
    fill: "#BCBEC0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M264.74 481.561C263.18 481.201 262.26 479.281 262.72 477.301C273.16 430.821 283.62 384.361 294.06 337.881C294.5 335.901 296.64 334.681 298.78 335.201C300.94 335.701 302.32 337.721 301.84 339.701C290.7 386.021 279.58 432.321 268.44 478.641C267.96 480.601 266.3 481.921 264.74 481.561Z",
    fill: "#B7B7B8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M289.939 369.98C289.939 369.98 337.599 372 359.899 363.9C382.199 355.78 385.759 263.02 385.759 247.3C385.759 231.58 343.679 235.24 311.239 243.3C302.099 285.34 289.939 369.98 289.939 369.98Z",
    fill: "#BCBEC0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M284.38 357.8C284.38 357.8 332.78 364.4 355.08 356.3C377.38 348.18 378.4 263.02 378.4 247.32C378.4 231.6 336.32 235.26 303.88 243.32C294.74 285.34 284.38 357.8 284.38 357.8Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M321.361 467.4L325.161 477.46L313.421 481.1L309.541 471.04L321.361 467.4Z",
    fill: "#F9B4A6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M312.381 478.36C312.381 478.36 284.141 487.68 282.621 490.88C281.101 494.1 284.141 494.68 295.881 493.92C307.621 493.16 327.121 492.48 329.721 491.46C332.341 490.44 329.181 477.62 324.421 475.5C320.261 478.04 316.061 479.36 312.381 478.36Z",
    fill: "#263238"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M227.94 459.78L223.4 469.62L209.5 472.54L214.24 453.96L227.94 459.78Z",
    fill: "#F9B4A6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M210.58 469.86C210.58 469.86 181.9 477.7 180.22 480.82C178.54 483.94 181.54 484.7 193.3 484.54C205.06 484.38 224.56 484.72 227.24 483.84C229.9 482.96 228.58 470.84 223.92 468.46C219.64 470.8 214.2 471.06 210.58 469.86Z",
    fill: "#263238"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M297.54 300.12C297.54 300.12 254.62 326.14 235.36 354.52C226.92 370.74 211 460.76 211 460.76L226.9 464.36C226.9 464.36 245.26 428.4 249.98 400.7C254.72 372.98 267.78 368.72 284.34 359.94C300.9 351.16 335.04 320.06 335.04 320.06L297.54 300.12Z",
    fill: "#133C63"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M347.38 317.58C347.38 317.58 352.86 330.18 336.18 348.96C322.58 364.26 295.28 374.14 288.18 382.24C307.78 413 322.7 467.68 322.7 467.68L308.04 472.82C308.04 472.82 271.88 407.26 261.74 388.34C251.6 369.42 259.72 361.98 266.48 352.18C273.24 342.38 310.08 310.96 310.08 310.96L347.38 317.58Z",
    fill: "#154B84"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M244.48 270.7C244.48 270.7 265.06 232 274.02 225.38C282.96 218.78 293.02 229.74 290.32 238.78C282.28 265.8 236.94 289.92 236.94 289.92C236.94 289.92 248.16 271.9 244.48 270.7Z",
    fill: "#D84154"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M283.02 215.3C283.02 215.3 306.6 208.96 325.18 238.02C343.76 267.08 347.4 317.58 347.4 317.58C347.4 317.58 316.52 334.56 283.4 309.54C286.78 281.82 287.14 265.8 283.22 254.3C278.4 240.26 272.2 215.64 283.02 215.3Z",
    fill: "#D84154"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M305.32 239.58C305.32 239.58 318.38 247.74 311.56 258.38C301.98 273.34 285.84 282.88 285.84 282.88L305.32 239.58Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M255.94 273.4C255.94 273.4 257.32 241.82 260.46 209.2C255.02 207.8 253.44 209.54 253.44 209.54C253.44 209.54 242 238.34 238.28 254.48C234.56 270.64 216.3 315.3 264.58 270.68C268.72 257.16 255.94 273.4 255.94 273.4Z",
    fill: "#D84154"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M277.181 244.84C277.181 244.84 287.121 243.22 280.301 253.86C270.721 268.82 247.141 285.1 247.141 285.1L277.181 244.84Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M285.84 214.7C291.44 217.54 283.12 232.78 270.66 236.74C258.22 240.72 275.84 209.64 285.84 214.7Z",
    fill: "#1D58A6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M282.22 215.72C282.22 215.72 275.54 207.86 275.78 204.14C275.72 204.22 275.66 204.34 275.6 204.42C274.66 194.5 269.46 193.22 263.56 192.24C257.34 191.22 247.3 195.42 247.3 195.42C247.3 195.42 246.32 201.82 249.16 211.94C252 222.06 255.78 230.8 264.78 228C266.26 227.54 267.54 226.94 268.68 226.22C270.94 228.08 273.9 230.68 274.16 231.6C277.54 231.18 282.6 222.98 283.12 219.68C283.6 216.4 282.22 215.72 282.22 215.72Z",
    fill: "#F9B4A6"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M242.78 195.3C242.78 195.3 250.18 199.06 260.86 197.06C266.16 196.88 267.88 198.18 268.44 201.52C269 204.86 271.04 207.38 271.46 209.02C272.52 209.58 273.2 208.68 273.2 208.68C273.2 208.68 271.4 205.68 272.9 203.14C274.38 200.62 275.28 202.68 275.8 204.82C276.32 206.96 276.44 210.12 277.26 211.66C278.02 213.06 281.54 215.84 282.2 215.72C283.06 206.94 286.86 200.54 284 189.4C281.14 178.26 272.86 180.9 272.86 180.9C272.86 180.9 265.36 171.1 255.76 176.08C246.14 181.06 238.3 187.36 235.48 187.04C236.72 191.64 242.78 195.3 242.78 195.3Z",
    fill: "#263238"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M284.72 205.36C284.72 205.36 284.24 212.88 266.14 195.78L249.2 193.2C236.96 190.44 231.46 180.92 230.86 175.58C230.6 174.48 231.48 173.42 232.62 173.48L250.46 174.28C272.98 158.42 301.44 180.38 284.72 205.36Z",
    fill: "#E32130"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_2001_14221",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 230,
    y: 168,
    width: 60,
    height: 40
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M284.72 205.36C284.72 205.36 284.24 212.88 266.14 195.78L249.2 193.2C236.96 190.44 231.46 180.92 230.86 175.58C230.6 174.48 231.48 173.42 232.62 173.48L250.46 174.28C272.98 158.42 301.44 180.38 284.72 205.36Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_2001_14221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.44 174.26C250.44 174.26 254.72 189.6 269.88 196.4C269.88 196.4 254.46 180.54 254.4 171.88C254.38 171.9 252.22 172.34 250.44 174.26Z",
    fill: "#1D58A6"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M276.381 173.24C280.521 175.2 281.881 172.24 277.741 170.34C273.601 168.38 272.201 171.34 276.381 173.24Z",
    fill: "#1D58A6"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M273.061 218.3C273.061 218.3 276.081 211.06 278.981 208.04C282.561 204.32 283.961 198.68 284.001 195.58C284.021 192.48 280.861 191.4 280.581 194.74C280.381 199.42 277.541 202.34 277.541 202.34C277.541 202.34 277.121 202.62 277.161 198.54C277.181 194.46 276.521 187.34 274.421 184.22C272.321 181.1 269.541 181.64 270.601 184.02C272.721 187.94 273.261 194.86 272.801 197.36C272.821 195.78 272.121 191.14 270.901 188.16C269.681 185.2 267.161 182.82 265.001 182.16C262.861 181.48 262.541 183.66 263.481 184.34C264.421 185.02 266.301 186.06 267.261 187.94C268.221 189.84 269.261 195.26 268.581 197.24C268.261 192.12 264.941 187.6 263.221 186.1C261.501 184.6 259.201 183.72 258.381 184.48C257.561 185.24 257.981 186.64 259.221 187.14C263.061 189.3 265.401 195.48 264.821 197.6C264.021 193.08 260.181 189.28 258.941 188.88C257.701 188.48 256.081 189.78 257.661 191.02C259.241 192.26 262.461 195.2 261.761 200.6C261.241 204.72 262.961 208.14 263.821 209.56C263.461 212.38 263.841 217.62 263.841 217.62L273.061 218.3Z",
    fill: "#F3ADA2"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M287.52 239.58C283.12 244.46 277.84 255.14 275.9 263.36C275.82 252.18 275.46 233.46 274.14 218.38C274.6 216.46 262.18 214.3 263.04 215.72C262.1 223.26 257.64 250.14 257 261.46C256.52 270.12 257.24 308.74 279.3 289.92C279.32 289.9 307.68 260.82 309.54 248.3C310.52 241.62 299.68 226.08 287.52 239.58Z",
    fill: "#D84154"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M115.56 480.98C117.64 481.52 119.9 479.88 120.58 477.34C136.56 417.7 152.54 358.06 168.54 298.42C169.22 295.88 167.44 293.18 164.56 292.44C161.7 291.7 158.82 293.18 158.18 295.72C143.1 355.6 128.04 415.46 112.96 475.34C112.3 477.92 113.48 480.44 115.56 480.98Z",
    fill: "#BCBEC0"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M300.92 499.96C298.8 500.32 296.68 498.42 296.2 495.74C285 432.9 273.78 370.08 262.58 307.24C262.1 304.56 264.1 301.96 267.02 301.46C269.94 300.96 272.7 302.74 273.14 305.44C283.42 368.44 293.7 431.42 303.98 494.42C304.4 497.1 303.04 499.6 300.92 499.96Z",
    fill: "#BCBEC0"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M152.48 499.96C154.6 500.32 156.72 498.42 157.2 495.74C168.4 432.9 179.62 370.08 190.82 307.24C191.3 304.56 189.3 301.96 186.38 301.46C183.46 300.96 180.7 302.74 180.26 305.44C169.98 368.44 159.7 431.42 149.42 494.42C149 497.1 150.36 499.6 152.48 499.96Z",
    fill: "#BCBEC0"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M298.9 305.52H140.56C137.58 305.52 135.16 303.08 135.16 300.12C135.16 297.14 137.6 294.72 140.56 294.72H298.9C301.88 294.72 304.3 297.16 304.3 300.12C304.32 303.1 301.88 305.52 298.9 305.52Z",
    fill: "#BCBEC0"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M221.361 289.28H146.041C144.721 289.28 143.581 288.36 143.281 287.08L129.381 235.34C128.981 233.58 132.821 232.62 134.621 232.62H209.941C211.261 232.62 212.401 233.54 212.701 234.82L224.121 285.84C224.501 287.6 223.161 289.28 221.361 289.28Z",
    fill: "#6A88BF"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M217.98 289.28H142.66C141.34 289.28 140.2 288.38 139.9 287.12L128.48 237.02C128.08 235.28 129.42 233.64 131.24 233.64H206.56C207.88 233.64 209.02 234.54 209.32 235.8L220.74 285.9C221.12 287.64 219.78 289.28 217.98 289.28Z",
    fill: "#7C95CC"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M273.2 294.72H142.6C141.1 294.72 139.88 293.5 139.88 292C139.88 290.5 141.1 289.28 142.6 289.28H273.18C274.68 289.28 275.9 290.5 275.9 292C275.92 293.48 274.7 294.72 273.2 294.72Z",
    fill: "#7C95CC"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M219.46 294.72H142.6C141.1 294.72 139.88 293.5 139.88 292C139.88 290.5 141.1 289.28 142.6 289.28H219.46C220.96 289.28 222.18 290.5 222.18 292C222.18 293.48 220.96 294.72 219.46 294.72Z",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M0 498H72.84",
    stroke: "#BCBEC0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M90.04 498H500",
    stroke: "#BCBEC0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2001_14221"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeNotFound);
export default __webpack_public_path__ + "static/media/office-not-found.42a977ac0b078130472f43738c7563ee.svg";
export { ForwardRef as ReactComponent };